import { LocalStorageService } from './../../services/local-storage.service';
import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SocketService } from '../../services/socket.service';
import { ButtonModule } from 'primeng/button';
import { environment } from '../../../environments/environment';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'home',
  imports: [CommonModule, RouterLink, ButtonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  dev: boolean = !environment.production;
  user = inject(UserService)
  nickname = computed(() => this.user.getCurrentUser());
  
  constructor(public socket: SocketService) {
    effect(() => {
      console.log('Connection status:', this.socket.connected());
    });
  }

  ngOnInit() {
    this.socket.connect();
  }

  toggleDarkMode() {
    const element = document.querySelector('html');
    element!.classList.toggle('my-app-dark');
  }
}
